export default "__VITE_ASSET__7ce795c6__"